import {
	EuiAccordion,
	EuiButtonIcon,
} from '@equipmentshare/ds2'

import GroupItem from '../GroupItem'

import { Group } from '../../index'

import styles from './groupRow.module.css'

export type GroupRowProps = {
	group: Group,
	isOpen: boolean,
	onToggle: () => void,
	onEditClick: () => void,
}

export default function GroupRow( { group, isOpen, onToggle, onEditClick }: GroupRowProps ) {
	return (
		<div className={styles.groupContainer}>
			<EuiAccordion
				id={`group-item-${group.id}`}
				forceState={isOpen ? 'open' : 'closed'}
				buttonContent={group.name}
				paddingSize="l"
				arrowDisplay="right"
				onToggle={onToggle}
				extraAction={(
					<EuiButtonIcon
						iconType="pencil"
						aria-label="Edit"
						onClick={onEditClick}
					/>
				)}
			>
				<GroupItem groupId={group.id} />
			</EuiAccordion>
		</div>
	)
}
